import * as views from '../../services/components/views'
import * as actions from '../../services/components/actions'

export default {
	state: {
		views,
		actions
	},

	getters: {

		columns: (state) => (entityType) => {
			return views[entityType].visibleProperties();
		},

		details: (state) => (entityType) => {
			return views[entityType].hiddenProperties();
		},

		properties: (state) => (entityType) => {
			return views[entityType].props;
		}
	}

};



// WEBPACK FOOTER //
// ./src/store/modules/tables.js